import { AppState } from '@redux/store'
import { config } from '@config/config'
import { getLocalAuthToken, hasCognitoSession } from '@utils/authToken'
import { sessionsApi } from './sessions'

const IGNORE_CONTENT_TYPE_ENDPOINTS = ['uploadFile']

const IGNORE_AUTH_ENDPOINTS = ['uploadFile', 'getPrescriptionFileBlob', 'getAttachmentBlob', 'getAttachmentBlobUrl']

const IGNORE_CUSTOMER_HEADER_ENDPOINTS = [
  'getInsurers',
  'getInsurerDetails',
  'getInsuranceProvider',
  'getDefaultForms',
  'getNullifyCount',
]

const APIKEY_ENDPOINTS = ['getAuthToken', 'getInsurersPublic', 'getInsuranceFormAttachmentUrl']

const isSkipContentType = (endpoint: string): boolean => IGNORE_CONTENT_TYPE_ENDPOINTS.includes(endpoint)

const isPublic = (endpoint: string): boolean => {
  return APIKEY_ENDPOINTS.includes(endpoint)
}

const isRequireAuth = (endpoint: string): boolean => {
  return !IGNORE_AUTH_ENDPOINTS.includes(endpoint)
}

const isRequireCustomerHeader = (endpoint: string): boolean => {
  return !endpoint.endsWith('Configuration') && !IGNORE_CUSTOMER_HEADER_ENDPOINTS.includes(endpoint)
}

export const dbPrepareHeaders = (headers: Headers, { getState, endpoint }) => {
  const state = getState() as AppState
  const token = getLocalAuthToken()
  const sessionId = state.connector.session?.sessionId ?? ''
  const { data: session } = sessionsApi.endpoints.getSession.select(sessionId)(state)

  if (!isSkipContentType(endpoint)) {
    headers.set('Content-Type', 'application/json')
  }

  if (isPublic(endpoint)) {
    headers.set('x-api-key', `${config.getApiKey(endpoint)}`)
  } else if (isRequireAuth(endpoint)) {
    if (token && hasCognitoSession(token)) {
      headers.set('Authorization', `Bearer ${token.accessToken}`)
    }

    if (session && isRequireCustomerHeader(endpoint)) {
      headers.set('x-directbilling-customer-number', session?.customer?.id)
      session?.customer?.email && headers.set('x-directbilling-customer-email', session?.customer?.email)
    }
  }

  return headers
}
